export default __webpack_public_path__ + "static/top-nav-do-2-a6a62bcbc8a915288f371f177fbc389c88056d6a119b020e54d17ea2c7fb9dfe.png";